(function () {
  'use strict';

  var EXCHANGE_RATES = {
    'INR': 1, 'USD': 0.012, 'GBP': 0.0095, 'EUR': 0.011,
    'CAD': 0.016, 'AUD': 0.018, 'AED': 0.044, 'SGD': 0.016
  };

  var CURRENCY_INFO = {
    'INR': { symbol: '₹', name: 'Indian Rupee', decimals: 0 },
    'USD': { symbol: '$', name: 'US Dollar', decimals: 2 },
    'GBP': { symbol: '£', name: 'British Pound', decimals: 2 },
    'EUR': { symbol: '€', name: 'Euro', decimals: 2 },
    'CAD': { symbol: 'C$', name: 'Canadian Dollar', decimals: 2 },
    'AUD': { symbol: 'A$', name: 'Australian Dollar', decimals: 2 },
    'AED': { symbol: 'د.إ', name: 'UAE Dirham', decimals: 2 },
    'SGD': { symbol: 'S$', name: 'Singapore Dollar', decimals: 2 }
  };

  var currentCurrency = 'INR';

  function getShopCurrency() {
    try {
      var cartJson = document.querySelector('[data-cart-json]');
      if (cartJson) return JSON.parse(cartJson.textContent).currency || 'INR';
    } catch (e) {}
    return 'INR';
  }

  function formatPrice(amountInPaise, currency) {
    var info = CURRENCY_INFO[currency] || CURRENCY_INFO['INR'];
    var rate = EXCHANGE_RATES[currency] || 1;
    var converted = (amountInPaise / 100) * rate;
    if (currency === 'INR') {
      return '₹' + Math.round(converted).toLocaleString('en-IN');
    } else {
      return info.symbol + converted.toFixed(info.decimals);
    }
  }

  function convertAllPrices() {
    document.querySelectorAll('[data-base-price]').forEach(function (el) {
      var basePaise = parseInt(el.getAttribute('data-base-price'), 10);
      if (!basePaise) return;
      el.textContent = formatPrice(basePaise, currentCurrency);
    });

    document.querySelectorAll('.cp-card__price').forEach(function (el) {
      var text = el.textContent.trim();
      var paise = parseFloat(text.replace(/[₹$£€A$C$S$د.إAED]/g, '').replace(/,/g, '')) * 100;
      if (paise > 0 && !el.getAttribute('data-base-price')) {
        el.setAttribute('data-base-price', Math.round(paise));
        el.textContent = formatPrice(Math.round(paise), currentCurrency);
      } else if (el.getAttribute('data-base-price')) {
        el.textContent = formatPrice(parseInt(el.getAttribute('data-base-price'), 10), currentCurrency);
      }
    });

    document.querySelectorAll('.cpdp-price').forEach(function (el) {
      var basePaise = el.getAttribute('data-base-paise');
      if (basePaise) {
        el.textContent = formatPrice(parseInt(basePaise, 10), currentCurrency);
      }
    });
  }

  function updateTrigger() {
    var trigger = document.querySelector('.currency-selector__trigger');
    if (!trigger) return;
    var info = CURRENCY_INFO[currentCurrency] || CURRENCY_INFO['INR'];
    trigger.innerHTML =
      '<span class="cs__symbol">' + info.symbol + '</span>' +
      '<span class="cs__code">' + currentCurrency + '</span>' +
      '<svg class="cs__caret" width="10" height="10" viewBox="0 0 20 20" fill="none">' +
      '<path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function updateOptions() {
    document.querySelectorAll('.currency-selector__option').forEach(function (opt) {
      var isActive = opt.dataset.currency === currentCurrency;
      opt.setAttribute('aria-selected', isActive);
      opt.classList.toggle('cs__option--active', isActive);
    });
  }

  function setCurrency(currency) {
    currentCurrency = currency;
    try { localStorage.setItem('selected_currency', currency); } catch (e) {}
    updateTrigger();
    updateOptions();
    convertAllPrices();
  }

  function detectCurrency() {
    var saved = null;
    try { saved = localStorage.getItem('selected_currency'); } catch (e) {}
    if (saved && CURRENCY_INFO[saved]) {
      currentCurrency = saved;
      return;
    }
    var countrySelect = document.querySelector('select[name="country_code"]');
    if (countrySelect) {
      var countryMap = {
        'IN': 'INR', 'US': 'USD', 'GB': 'GBP', 'CA': 'CAD',
        'AU': 'AUD', 'AE': 'AED', 'SG': 'SGD',
        'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR', 'ES': 'EUR', 'NL': 'EUR'
      };
      var code = countrySelect.value;
      if (code && countryMap[code]) currentCurrency = countryMap[code];
    }
  }

  function initDropdown() {
    var btn = document.querySelector('.currency-selector__trigger');
    var dropdown = document.querySelector('.currency-selector__dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = !dropdown.hasAttribute('hidden');
      if (isOpen) {
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.currency-selector')) {
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    document.querySelectorAll('.currency-selector__option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        setCurrency(opt.dataset.currency);
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    detectCurrency();
    updateTrigger();
    updateOptions();
    initDropdown();
    convertAllPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window._currencyConverter = { convertAllPrices: convertAllPrices, setCurrency: setCurrency };
})();
